import { SortDirection } from '@mui/material';

export class SortOrder {
    sortKey: string
    sortDirection: SortDirection

    constructor(sortKey: string, sortOrder: SortDirection) {
        this.sortKey = sortKey
        this.sortDirection = sortOrder
    }
}
